﻿import { Bar } from "./bars";
import * as signalR from "@microsoft/signalr";
import { formatPrice } from "./formatters";
declare const htmlPrefixMap: Map<number, string>;
declare const barChart: any;

let bars: Bar[] = [];
let timerId: NodeJS.Timeout;

export function startBuildingBars() {
  if (typeof barChart !== "undefined") {
    $("#mainchartPeriod").on("change", function () {
      const instrumentType = $("#instrumentType").val();
      if (!instrumentType) {
        return;
      }

      const symbol = $("#symbol").val();
      if (!symbol) {
        return;
      }

      const periodAsString = ((this as any).value);
      let period: number = 0;
      switch (periodAsString) {
        case "1min": {
          period = 60;
          break;
        }
        case "5min": {
          period = 300;
          break;
        }
        case "15min": {
          period = 900;
          break;
        }
        case "30min": {
          period = 1800;
          break;
        }
        case "1hour": {
          period = 3600;
          break;
        }
        case "4hours": {
          period = 14400;
          break;
        }
        case "daily": {
          period = 86400;
          break;
        }
        case "weekly": {
          period = 604800;
          break;
        }
        default: {
          return;
        }
      }

      fetch(`/historical-data?instrumentType=${instrumentType}&symbol=${symbol}&barSize=${period}`)
        .then((response) => {
          return response.json();
        })
        .then((data: number[][]) => {
          // console.log("historical data:", data);
          // barChart.series[0].remove(true);
          const ohlc: number[][] = [];
          // const volume: number[][] = [];

          for (let i = 0; i < data.length; i++) {
            ohlc.push([
              data[i][0],
              data[i][1],
              data[i][2],
              data[i][3],
              data[i][4]
            ]);
          }

          barChart.series[0].setData(ohlc);
          // barChart.series[1].setData(volume);
          // console.log("launchbb");
          launchBarBuilding(period * 1000);
          barChart.redraw();

        })
        .catch((err) => console.error(err.toString()));
    });

    launchBarBuilding(60000);
  }
}

export function subscribeToInstrumentsUpdate(connection: signalR.HubConnection) {
  const pageInstrumentIdAsString = $("#instrumentId").val() as string;
  const pageInstrumentId = pageInstrumentIdAsString ? parseInt(pageInstrumentIdAsString, 10) : undefined;

  connection.on("UpdateInstrument",
    (instrumentId: number, typeId: number, dateTime: string, price: number, size: number, priceFormat?: string) => {
      try {
        if (Number.isSafeInteger(pageInstrumentId) && instrumentId !== pageInstrumentId) {
          return; // use only specific instrument ticks on instrument page
        }

        if (typeof htmlPrefixMap !== "undefined") {
          updateInstrumentRow({
            instrumentId,
            dateTime,
            typeId,
            price,
            size,
            priceFormat
          });
        }

        if (typeof barChart !== "undefined" && typeId === 2) {
          updateCurrentBar(dateTime, price, size);
          updateChart();
        }

      } catch (error: any) {
        console.error(error.toString());
      }
    });
}

function launchBarBuilding(barInterval: number) {
  // console.log(`start building bars with interval: ${barInterval} ms`);
  clearInterval(timerId);
  bars = [];
  addNextBar();
  timerId = global.setInterval(() => {
    addNextBar();
  }, barInterval);
}

function addNextBar() {
  bars.push({
    open: 0,
    high: Number.MIN_SAFE_INTEGER,
    low: Number.MAX_SAFE_INTEGER,
    close: 0,
    volume: 0
  });
}

function updateCurrentBar(dateTime: string, price: number, size: number) {
  const bar = bars[bars.length - 1];
  // console.log("barslength2", bar);
  if (bar) {
    let newBarAdded = false;

    if (bar.timestamp === undefined) {
      bar.timestamp = new Date(dateTime).getTime();
      // bar.timestamp = new Date(dateTime).getTime() - (new Date(dateTime).getSeconds() * 1000) - new Date(dateTime).getMilliseconds();
      newBarAdded = true;
    }

    if (bar.open === 0) {
      bar.open = price;
    }

    if (price > bar.high) {
      bar.high = price;
    }

    if (price < bar.low) {
      bar.low = price;
    }

    bar.close = price;

    if (newBarAdded) {
      // console.log("adding points for bar:", bar);
      if (barChart.series[0].data.length > 0) {
        barChart.series[0].data[barChart.series[0].data.length - 1].update([bar.timestamp, bar.open, bar.high, bar.low, bar.close], false);
      }
    }
  } else {
    // console.log('bar not found');
  }
}

function updateChart() {
  const bar = bars[bars.length - 1];
  if (!bar) {
    // console.log("current bar is invalid:", bar);
    return;
  }

  // console.log("updating current bar:", bar);
  // console.log("barslength", bars.length);
  // console.log("barChart series length", barChart.series[0].data.length);

  const ohlcDataLength = barChart.series[0].data.length;
  if (ohlcDataLength > 0) {
    // barChart.series[0].data[ohlcDataLength - 1].remove();
    // console.log("removeohlc.point", ohlcDataLength);
  }

  barChart.series[0].addPoint(
    [bar.timestamp, bar.open, bar.high, bar.low, bar.close],
    true, false);
  // console.log("addohlc.point");

}

function updateInstrumentRow(parameters: any) {
  const htmlPrefix = htmlPrefixMap.get(parameters.instrumentId);
  if (!htmlPrefix) {
    return;
  }

  switch (parameters.typeId) {
    case 2: {
      $(`.${htmlPrefix}-bid-price`).text(formatPrice(parameters.price, parameters.priceFormat));
      $(`.${htmlPrefix}-bid-size`).text(parameters.size);
      break;
    }
    case 3: {
      $(`.${htmlPrefix}-ask-price`).text(formatPrice(parameters.price, parameters.priceFormat));
      $(`.${htmlPrefix}-ask-size`).text(parameters.size);
      break;
    }
    case 4: {
      $(`.${htmlPrefix}-trade-price`).text(formatPrice(parameters.price, parameters.priceFormat));
      break;
    }
    default: {
      console.log("unknown type id: ", parameters.typeId);
    }
  }
}

